import { useEffect, useState } from 'react';
import getCalendars from '../api/graphql/queries/getCalendars';

const useCalendars = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    getCalendars().then((data) => {
      const options = data.map(item => ({ label: item.google_name || '', value: item.id }));
      setItems(options);
    });
  }, []);

  return items;
};

export default useCalendars;
